import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup } from 'react-bootstrap';

import TooltipButton from '../TooltipButton';

const PaymentToolbar = (props) => {
  const {
    selectedId, onDetails, onFilter, showFilter,
  } = props;

  return (
    <ButtonGroup>
      <TooltipButton variant="dark" onClick={onFilter} tooltip="Filter Payments" aria-controls="payment-filter" aria-expanded={showFilter}>
        Filter
      </TooltipButton>
      {selectedId ? (
        <TooltipButton variant="info" onClick={onDetails} tooltip="Payment Details">
          Details
        </TooltipButton>
      ) : null}
    </ButtonGroup>
  );
};

PaymentToolbar.propTypes = {
  selectedId: PropTypes.number,
  onDetails: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
  showFilter: PropTypes.bool.isRequired,
};

PaymentToolbar.defaultProps = {
  selectedId: undefined,
};

export default PaymentToolbar;
